import { type TenantStatusName } from "@packsize/identity-api-sdk";
import { useToken, useUser } from "@packsize/authentication";

export const useTenantStatus = (): TenantStatusName | undefined => {
	const { decodedToken } = useToken();
	const { currentUser, isPacksizeUser } = useUser();

	const currentTenant = currentUser?.userTenants?.find((tenant) => tenant.id === decodedToken?.tid);

	if (!isPacksizeUser) {
		return undefined;
	}

	return currentTenant?.tenantStatus?.name;
};
